module.exports = __webpack_public_path__ + "img/ic_24_apple.2a19e73c.svg";